import { S3Client } from "@aws-sdk/client-s3"
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers"
import { FileWithPath } from "react-dropzone"
import { ImageOrientationEnum } from "./types"

// Create the credential provider
const cognitoCredentials = fromCognitoIdentityPool({
  clientConfig: { region: "us-east-2" },
  identityPoolId: "us-east-2:54419292-052c-4396-a845-5c77deea932b",
})

// Pre-warm credentials on module load to avoid first-upload failure
let credentialsWarmed = false
export const warmS3Credentials = async () => {
  if (!credentialsWarmed) {
    try {
      await cognitoCredentials()
      credentialsWarmed = true
    } catch (err) {
      console.error("Failed to warm S3 credentials:", err)
    }
  }
}

export const iconKey = {
  favorites:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-heart-outline.png",
  music:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-music.png",
  food: "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-burger.png",
  sports:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-sport.png",
  comedy:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-comedy.png",
  trivia:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-trivia.png",
  art: "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-art.png",
  culture:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-culture.png",
  drinks:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-drink.png",
  history:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-history.png",
  nature:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-nature.png",
  entertainment:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-entertainment.png",
  theatre:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-theatre.png",
  education:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-education.png",
  philanthropy:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-philanthropy.png",
  shopping:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/blue-shopping.png",
  attractions:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/attractions.png",
  arrowButton:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/arrow.svg",
  filter:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/filter.png",
}

export const attractionIconKeys = {
  favorites:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/white-heart-outline.png",
  adventure:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/white-adventure.png",
  architecture:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/white-architecture.png",
  art: "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/white-art.png",
  history:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/white-history.png",
  museums:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/white-museum.png",
  nature:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/white-nature.png",
  water:
    "https://eightfourthree-assets.s3.us-east-2.amazonaws.com/mapFilterButtons/white-water.png",
}

export type ImageType = {
  file: FileWithPath
  orientation: ImageOrientationEnum
  order: number
}

export const s3 = new S3Client({
  region: "us-east-2",
  credentials: cognitoCredentials,
})

// Warm credentials immediately on module load
warmS3Credentials()
